import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Img1 from "./termConditionImg/term1.jpeg";
import Img2 from "./termConditionImg/term2.jpeg";
import Img3 from "./termConditionImg/term3.jpeg";
import CertificateCard from "../CertificateCard/CertificateCard";
import { FaMinus, FaPlus } from "react-icons/fa6";

const Faq = () => {
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [expanded, setExpanded] = useState(false);

  const handleToggle = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <>
      <Header />
      <main>
        <Stack>
          <Stack
            sx={{
              //   border: "1px solid red",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: { sm: "20vh", xs: "15vh" },
              gap: 4,
              backgroundColor: "black",
            }}
          >
            <Stack
              sx={{
                fontSize: {
                  xl: "60px",
                  lg: "60px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 400,
                color: "white",
                lineHeight: "24px",
                fontFamily:
                  "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
              }}
            >
              FAQ's
            </Stack>
            <Stack
              sx={{
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  sm: "20px",
                  xs: "16px",
                },
                fontWeight: 400,
                color: "white",
                lineHeight: "24px",
                fontFamily:
                  "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
              }}
            >
              HOME / FAQ's
            </Stack>
          </Stack>
          <Stack
            sx={{
              height: "auto",
              display: "flex",
              flexDirection: { xl: "row" },
              justifyContent: "center",
              // border: "1px solid blue",
            }}
          >
            <Stack sx={{ width: { xl: "70%" } }}>
              {/* Header Section */}

              {/* Cotent Section */}

              <Stack
                sx={{
                  marginTop: "60px",
                  //   border: "3px solid green",
                  dispaly: "flex",
                  flexDirection: {
                    xl: "row",
                    lg: "row",
                    md: "row",
                    sm: "row",
                    xs: "column",
                  },
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  sx={{
                    width: { xl: "70%", lg: "70%", md: "70%", sm: "70%" },
                    // border: "4px solid blue",
                    // border: "1px solid #d1d1d1",
                    borderRadius: "8px",
                    padding: "16px",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    color: "#333",
                    lineHeight: "1.6",
                    fontFamily: "Arial, sans-serif",
                    fontSize: "14px",
                    overflow: "hidden",
                  }}
                >
                  <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleToggle("panel1")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel1" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel1" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        What is WhatsApp Business API?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        WhatsApp Business API enables businesses to automate
                        customer communication, send notificationsand provide
                        a personalized experience at scale using WhatsApp.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleToggle("panel2")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel2" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel2" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        How is WhatsApp Business API different from the WhatsApp
                        Business App?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        The API is designed for medium to large businesses,
                        offering advanced features like automation,
                        broadcastingand CRM integration, while the app is for
                        small businesses with limited functionality.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel3"}
                    onChange={handleToggle("panel3")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel3" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel3" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can businesses of all sizes use the WhatsApp Business
                        API?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Yes, businesses of all sizes can use it. However, it is
                        best suited for medium to large-scale businesses
                        requiring automation and bulk messaging capabilities.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel4"}
                    onChange={handleToggle("panel4")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel4" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel4" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel4a-content"
                      id="panel4a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        What documents are required for onboarding?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          marginBottom: "8px", // Add spacing below the heading
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        You'll need:
                      </Typography>

                      <ul
                        style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          paddingLeft: "20px", // Indentation for the bullet points
                          margin: "0", // Remove default margin
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        <li>
                          GST Number (or MSME Certificate if GST is not
                          available)
                        </li>
                        <li>A verified business name</li>
                        <li>Facebook Business Manager account</li>
                        <li>A phone number not registered on WhatsApp</li>
                      </ul>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel5"}
                    onChange={handleToggle("panel5")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel5" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel5" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel5a-content"
                      id="panel5a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can I use my existing WhatsApp number?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        No, you need a phone number that is not already linked
                        to a personal or business WhatsApp account.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel6"}
                    onChange={handleToggle("panel6")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel6" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel6" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel6a-content"
                      id="panel6a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        How long does the onboarding process take?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Onboarding typically takes 5–7 business days after
                        submission of all required documents.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel7"}
                    onChange={handleToggle("panel7")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel7" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel7" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel7a-content"
                      id="panel7a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Is GST mandatory?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        No, if you don't have a GST number, you can use an MSME
                        certificate to onboard.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel8"}
                    onChange={handleToggle("panel8")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel8" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel8" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel8a-content"
                      id="panel8a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Which payment gateways are supported with WhatsApp
                        Business API?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Supported gateways include:
                      </Typography>
                      <ul
                        style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          paddingLeft: "20px", // Indentation for the bullet points
                          margin: "0", // Remove default margin
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        <li>Razorpay</li>
                        <li>PayU</li>
                        <li>Cashfree</li>
                        <li>BillDesk</li>
                      </ul>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel9"}
                    onChange={handleToggle("panel9")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel9" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel9" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel9a-content"
                      id="panel9a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can customers complete payments within WhatsApp?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Yes, customers can securely complete payments using
                        integrated gateways directly within the WhatsApp chat.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={expanded === "panel10"}
                    onChange={handleToggle("panel10")}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f4f4ff",
                      },
                      backgroundColor:
                        expanded === "panel10" ? "#f4f4ff" : "none",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === "panel10" ? (
                          <FaMinus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        ) : (
                          <FaPlus
                            style={{ fontSize: "24px", color: "#5858e0" }}
                          />
                        )
                      }
                      aria-controls="panel10a-content"
                      id="panel10a-header"
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xl: "20px",
                            lg: "20px",
                            sm: "20px",
                            xs: "16px",
                          },
                          fontWeight: 600,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "31px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Can I use UPI-based payments for Indian customers?
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "rgb(0, 0, 0)",
                          lineHeight: "25px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Yes, payment gateways like Razorpay, Cashfreeand
                        Google Pay API support UPI transactions for Indian
                        users.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Stack>
                <Stack
                  sx={{
                    width: { xl: "30%", lg: "30%", md: "30%", sm: "30%" },
                    // border: "1px solid red",
                    dispaly: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Stack
                    sx={{
                      border: "none",
                      width: "100%",
                      padding: "16px",
                      fontFamily: "'Arial', sans-serif",
                      color: "#333",
                      lineHeight: "1.8",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "16px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      CATEGORIES
                    </h3>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Blog
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Inventory & Order Management
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Multi-Vendor
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontSize: "16px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Social Commerce
                      </li>
                    </ul>
                    <Stack
                      sx={{
                        borderTop: "1px solid #ddd",
                        marginBottom: "20px",
                        width: { xl: "80%" },
                      }}
                    ></Stack>
                  </Stack>
                  <Stack
                    sx={{
                      border: "none",
                      width: "300px",
                      padding: "16px",
                      fontFamily: "'Arial', sans-serif",
                      color: "#333",
                      lineHeight: "1.6",
                      backgroundColor: "#fff",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "16px",
                        color: "#000",
                        // borderBottom: "1px solid #ddd",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      RECENT POSTS
                    </h3>

                    {/* Post 1 */}
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        borderBottom: "1px solid #ddd",
                        paddingBottom: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      <img
                        src={Img1}
                        alt="Post 1"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <h4
                          style={{
                            fontSize: "16px",
                            margin: "0 0 8px 0",
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.color = "#0073e6"; // Hover color
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.color = "#333"; // Default color
                          }}
                        >
                          Setup and Operational Costs for WhatsApp Business API:
                          Key Dependencies
                        </h4>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            color: "#777",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          November 21, 2024 &nbsp;&nbsp; No Comments
                        </p>
                      </div>
                    </Stack>

                    {/* Post 2 */}
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        borderBottom: "1px solid #ddd",
                        paddingBottom: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      <img
                        src={Img2}
                        alt="Post 2"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <h4
                          style={{
                            fontSize: "16px",
                            margin: "0 0 8px 0",
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.color = "#0073e6"; // Hover color
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.color = "#333"; // Default color
                          }}
                        >
                          Why WhatsApp Business API Policies Matter?
                        </h4>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            color: "#777",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          November 20, 2024 &nbsp;&nbsp; No Comments
                        </p>
                      </div>
                    </Stack>

                    {/* Post 3 */}
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        borderBottom: "1px solid #ddd",
                        paddingBottom: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      <img
                        src={Img3}
                        alt="Post 3"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "4px",
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <h4
                          style={{
                            fontSize: "16px",
                            margin: "0 0 8px 0",
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.color = "#0073e6"; // Hover color
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.color = "#333"; // Default color
                          }}
                        >
                          WhatsApp Business API top features
                        </h4>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            color: "#777",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          November 20, 2024 &nbsp;&nbsp; No Comments
                        </p>
                      </div>
                    </Stack>
                  </Stack>
                  <Stack
                    sx={{
                      width: "100%",
                      padding: "16px",
                      fontFamily: "'Arial', sans-serif",
                      color: "#333",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "16px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      OUR INSTAGRAM
                    </h3>
                    <Stack direction="row" spacing={2}>
                      {/* Card 1 */}
                      <div
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "8px",
                          overflow: "hidden",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          transition: "background-color 0.3s ease",
                          backgroundColor: "#f7f4e6", // Matching the background of the first card
                          borderBottom: "1px solid #ddd",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.border = "2px solid #ffffff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.border = "transparent";
                        }}
                      >
                        <img
                          src={Img1}
                          alt="Instagram Post 1"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      {/* Card 2 */}
                      <div
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "8px",
                          overflow: "hidden",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          transition: "background-color 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.border = "2px solid #ffffff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.border = "transparent";
                        }}
                      >
                        <img
                          src={Img2}
                          alt="Instagram Post 2"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </Stack>
                  </Stack>
                  <Stack
                    sx={{
                      width: "300px",
                      padding: "16px",
                      fontFamily: "'Arial', sans-serif",
                      color: "#333",
                      lineHeight: "1.6",
                    }}
                  >
                    <Stack
                      sx={{ borderTop: "1px solid #ddd", marginBottom: "60px" }}
                    ></Stack>
                    <h3
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "16px",
                        color: "#000",
                      }}
                    >
                      RECENT COMMENTS
                    </h3>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {/* Comment 1 */}

                      <li style={{ marginBottom: "16px" }}>
                        <span style={{ fontSize: "14px", color: "#555" }}>
                          <span style={{ fontWeight: "bold" }}>
                            vinod gupta
                          </span>{" "}
                          on{" "}
                          <a
                            href="#"
                            style={{
                              textDecoration: "none",
                              color: "#0073e6",
                              fontWeight: "normal",
                              fontFamily:
                                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                            }}
                          >
                            Send 1000 bulk messages on WhatsApp | WhatsApp bulk
                            sender
                          </a>
                        </span>
                      </li>

                      {/* Comment 2 */}
                      <li style={{ marginBottom: "16px" }}>
                        <span style={{ fontSize: "14px", color: "#555" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              fontFamily:
                                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                            }}
                          >
                            Top 10 Business Fields Where
                          </span>{" "}
                          on{" "}
                          <a
                            href="#"
                            style={{
                              textDecoration: "none",
                              color: "#0073e6",
                              fontWeight: "normal",
                              fontFamily:
                                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                            }}
                          >
                            WhatsApp Business API Can Facilitate Growth - Vertex
                            Suite on Tips for Effective Messaging on WhatsApp
                          </a>
                        </span>
                      </li>

                      {/* Comment 3 */}
                      <li style={{ marginBottom: "16px" }}>
                        <span style={{ fontSize: "14px", color: "#555" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              fontFamily:
                                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                            }}
                          >
                            Documents Required for
                          </span>{" "}
                          on{" "}
                          <a
                            href="#"
                            style={{
                              textDecoration: "none",
                              color: "#0073e6",
                              fontWeight: "normal",
                              fontFamily:
                                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                            }}
                          >
                            Integrating WhatsApp Business API into Your Business
                            - Vertex Suite on WhatsApp E-commerce Store
                          </a>
                        </span>
                      </li>
                    </ul>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default Faq;
